import {
  OPEN_HAMBURGER_MENU,
  OPEN_SEARCHBAR,
  MEMBER_UPDATED,
  IS_OPEN_LOGIN_FORM,
  STORY_HEADER_IN_VIEW,
  TOAST_MESSAGE,
} from "./actions";

function hamburgerMenuReducer(state = false, action) {
  switch (action.type) {
    case OPEN_HAMBURGER_MENU:
      return action.isHamburgerMenuOpen;
    default:
      return state;
  }
}

function searchBarReducer(state = false, action) {
  switch (action.type) {
    case OPEN_SEARCHBAR:
      return action.isSearchBarOpen;
    default:
      return state;
  }
}

function memberReducer(state = null, action) {
  switch (action.type) {
    case MEMBER_UPDATED:
      return action.member;

    default:
      return state;
  }
}

function loginReducer(state = false, action) {
  switch (action.type) {
    case IS_OPEN_LOGIN_FORM:
      return action.payload;
    default:
      return state;
  }
}

const userIntialState = {
  jwt_token: null,
};

function userReducer(state = userIntialState, action) {
  switch (action.type) {
    case "METYPE_JWT_TOKEN":
      return {
        ...state,
        jwt_token: action.payload,
      };

    default:
      return state;
  }
}

function storyHeaderReducer(state = true, action) {
  switch (action.type) {
    case STORY_HEADER_IN_VIEW:
      return action.payload;
    default:
      return state;
  }
}

function toastMessageReducer(state = "", action) {
  switch (action.type) {
    case TOAST_MESSAGE:
      return action.message;
    default:
      return state;
  }
}

export const REDUCERS = {
  isHamburgerMenuOpen: hamburgerMenuReducer,
  isSearchBarOpen: searchBarReducer,
  member: memberReducer,
  isLoginOpen: loginReducer,
  userReducer: userReducer,
  storyHeaderInView: storyHeaderReducer,
  toastMessage: toastMessageReducer,
};
